import * as React from "react";
import { getAuthSnapshot, subscribeAuth } from "./auth-store.js";
import type { AuthState } from "./auth-store.js";

export function useAuth(): AuthState {
  return React.useSyncExternalStore(subscribeAuth, getAuthSnapshot, getAuthSnapshot);
}

/** Convenience selector for permission-gated UI — `07_UI_UX_SPEC.md` §2: "hiding is usability only, never security". */
export function useHasPermission(permissionCode: string): boolean {
  const { permissions } = useAuth();
  return permissions.includes(permissionCode);
}
